export default function Hero() {
  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden"
    >
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dark%20cinematic%20movie%20theater%20atmosphere%20with%20warm%20red%20and%20golden%20ambient%20lighting%2C%20soft%20bokeh%20effects%2C%20elegant%20film%20reel%20texture%20in%20background%2C%20sophisticated%20entertainment%20aesthetic%2C%20abstract%20cinematic%20composition%2C%20professional%20photography%20with%20dramatic%20mood&width=1600&height=900&seq=hero-bg-mahua&orientation=landscape"
          alt="麻花影视 - 影视资源聚合平台背景"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/45 to-black/70"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 py-16 md:py-20">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-4 py-1.5 rounded-full text-xs md:text-sm font-medium bg-accent-500/20 text-accent-300 border border-accent-500/30 mb-5 whitespace-nowrap">
              影视资源聚合平台
            </span>
            <h1 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-white leading-tight mb-4">
              麻花影视 · 全网影视一站聚合
            </h1>
            <p className="text-lg md:text-xl text-white/80 font-heading mb-6">
              聚合多平台优质资源，畅享高清观影体验
            </p>
            <p className="text-sm md:text-base text-white/65 leading-relaxed max-w-xl mx-auto lg:mx-0 mb-8">
              麻花影视整合神马影视、樱花影视、小小影视、久久影视、飘花影视、丫丫影视、琪琪影视等主流平台影视资源，为您提供丰富的替代观影选择。无论是最新热播剧集、院线大片，还是经典老片、小众佳作，都能在这里找到高清流畅的播放源。每日持续更新，覆盖海量内容，让观影不再受平台限制。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 md:gap-8 mb-8">
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading font-bold text-accent-400">8+</div>
                <div className="text-xs md:text-sm text-white/55 mt-1">覆盖主流平台</div>
              </div>
              <div className="w-px h-10 bg-white/15 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading font-bold text-accent-400">500+</div>
                <div className="text-xs md:text-sm text-white/55 mt-1">日均内容更新</div>
              </div>
              <div className="w-px h-10 bg-white/15 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading font-bold text-accent-400">10万+</div>
                <div className="text-xs md:text-sm text-white/55 mt-1">小时高清资源</div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#cards"
                className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-3 rounded-lg bg-primary-500 hover:bg-primary-600 text-white font-medium text-sm md:text-base transition-all duration-200 cursor-pointer whitespace-nowrap"
              >
                <i className="ri-play-circle-line text-lg"></i>
                立即观影
              </a>
              <a
                href="#features"
                className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-3 rounded-lg bg-white/10 hover:bg-white/20 text-white border border-white/25 font-medium text-sm md:text-base transition-all duration-200 cursor-pointer whitespace-nowrap"
              >
                <i className="ri-information-line text-lg"></i>
                了解优势
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-md lg:max-w-none">
            <div className="relative aspect-[4/3] rounded-xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Cinematic%20film%20collection%20display%20with%20warm%20golden%20and%20red%20ambient%20lighting%2C%20movie%20posters%20and%20film%20reels%20artistic%20composition%2C%20sophisticated%20home%20theater%20atmosphere%2C%20elegant%20entertainment%20lifestyle%2C%20professional%20photography%20with%20dramatic%20shadows%20and%20rich%20textures&width=1200&height=900&seq=hero-visual-mahua&orientation=landscape"
                alt="麻花影视 - 聚合观影体验"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 rounded-xl ring-1 ring-inset ring-white/10"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}